import { render, staticRenderFns } from "./InstitutionalSection.vue?vue&type=template&id=042276c0&scoped=true"
import script from "./InstitutionalSection.vue?vue&type=script&lang=js"
export * from "./InstitutionalSection.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalSection.vue?vue&type=style&index=0&id=042276c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042276c0",
  null
  
)

export default component.exports